import type { CarPerf } from './car';

/**
 * Daily Grand Prix conditions and twists (design.md B14.3), as plain
 * multipliers on a car's performance. Arithmetic only (deterministic).
 */
export interface Mods {
  vmax?: number;
  accel?: number;
  grip?: number;
  offroad?: number;
}

export function applyMods(perf: CarPerf, mods: Mods | null | undefined): CarPerf {
  if (!mods) return perf;
  const out: CarPerf = { vmax: perf.vmax, accel: perf.accel };
  if (mods.vmax !== undefined) out.vmax = perf.vmax * mods.vmax;
  if (mods.accel !== undefined) out.accel = perf.accel * mods.accel;
  if (mods.grip !== undefined) out.grip = mods.grip;
  if (mods.offroad !== undefined) out.offroad = mods.offroad;
  return out;
}

export function combineMods(a: Mods, b: Mods): Mods {
  const m: Mods = {};
  for (const k of ['vmax', 'accel', 'grip', 'offroad'] as const) {
    const x = a[k];
    const y = b[k];
    if (x !== undefined || y !== undefined) m[k] = (x ?? 1) * (y ?? 1);
  }
  return m;
}
